import { EN } from "./en";
import { NL } from "./nl";
import { useLang } from "@/i18n/LanguageContext";

const u = (id, w = 1600) => `https://images.unsplash.com/${id}?auto=format&fit=crop&w=${w}&q=80`;

export const IMAGES = {
  hero: "/images/hero.jpg",
  firstBleed: u("photo-1503454537195-1dcabb73ffb9"),
  pregnancy: "https://images.pexels.com/photos/33665727/pexels-photo-33665727.jpeg?auto=compress&cs=tinysrgb&w=1600",
  menopause: u("photo-1508214751196-bcfd4ca60f91"),
  irida: "/irida.jpg",
  circle: "https://images.pexels.com/photos/25636763/pexels-photo-25636763.jpeg?auto=compress&cs=tinysrgb&w=1600",
  botanical: "https://images.pexels.com/photos/3401811/pexels-photo-3401811.jpeg?auto=compress&cs=tinysrgb&w=2000",
  ritualConsultation: "/images/ritual-consultation.jpg",
  activeBirth: u("photo-1544367567-0f2fcb009e0b"),
  birthArt: u("photo-1460661419201-fd4cecdf8a8b"),
  thaiMassage: u("photo-1544161515-4ab6ce6db874"),
  menopauseSupport: u("photo-1518310383802-640c2de311b2"),
  baby: u("photo-1519689680058-324335c77eba"),
  field: u("photo-1470252649378-9c29740c9fa8"),
};

export const THRESHOLD_IMAGES = {
  "first-bleed": "/images/menarche.jpg",
  "pregnancy-motherhood": "/images/pregnancy.jpg",
  "menopause": "/images/menopause-threshold.jpg",
};

export const OFFERING_IMAGES = {
  "first-period": "/images/menarche.jpg",
  "active-birth": "/images/active-birth.jpg",
  "birth-art": "/images/birth-art.jpg",
  "mums-babies-circle": "/images/circle.jpg",
  "thai-massage": "/images/thai-massage.jpg",
  "one-to-one-mothers": "/images/postpartum.jpg",
  "menopause-support": "/images/irida-casual.jpg",
};

export const JOURNAL_IMAGES = {
  "birth-as-a-rite-of-passage-reclaiming-the-power-of-birth": "/images/active-birth.jpg",
  "geboorte-als-overgangsritueel-de-kracht-van-geboorte-herwaarderen": "/images/active-birth.jpg",
  "menopause-a-time-of-change-and-becoming": "/images/menopause.jpg",
  "een-tijd-van-verandering-en-worden": "/images/menopause.jpg",
  "the-wisdom-of-thresholds": IMAGES.field,
  "de-wijsheid-van-drempels": IMAGES.field,
  "postpartum-recovery-gentle-support-for-new-mothers": "/images/postpartum.jpg",
  "postpartum-herstel-zachte-ondersteuning-voor-nieuwe-moeders": "/images/postpartum.jpg",
  "understanding-dutch-maternity-care-from-pregnancy-to-the-kraamweek": IMAGES.baby,
  "nederlandse-geboortezorg-begrijpen-van-zwangerschap-tot-de-kraamweek": IMAGES.baby,
};

export const CONTACT = {
  email: "contactirida@gmail.com",
  phone: "0031 6 8187 3550",
  phoneHref: "+31681873550",
  area: "Schiedam · Rotterdam",
  bookingUrl: "https://tidycal.com/iridaa11",
  instagram: "https://www.instagram.com/irida.hysenbelli",
  instagramHandle: "@irida.hysenbelli",
  massage90Url: "https://tidycal.com/iridaa11/pregnancy-postpartum-thai-massage",
  massage120Url: "https://tidycal.com/iridaa11/pregnancy-postpartum-thai-massage-120min",
  introCallUrl: "https://tidycal.com/iridaa11/15-minute-chat",
  mothersSessionUrl: "https://tidycal.com/iridaa11/motherhood-1-1-90-minutes",
};

const CONTENT = { en: EN, nl: NL };

export const useContent = () => {
  const { lang } = useLang();
  return CONTENT[lang] || EN;
};
